import { ColorField } from '@anm/components/ColorPicker/ColorPickerField/Wrapper';
import Loader from '@anm/components/Loader';
import { media } from '@anm/styles/helpers';
import styled from 'styled-components';
import { CheckboxWrapper } from '../../../CustomizationForm/CustomizationFormCheckbox';

export const TabUrlParametersWrapper = styled.div`
  margin: -22px 0 24px;
`;
const landingTabWrapperResponsive = media.tablet`
  padding: 0 19px;
  margin: 0
`;

export const LandingContentWrapper = styled.div`
  margin: 31px 0 150px 0;
  ${landingTabWrapperResponsive};

  ${CheckboxWrapper} {
    &:not(:last-of-type) {
      margin-bottom: 10px;
    }
  }
`;

export const ShareWrapper = styled.div`
  margin-bottom: 18px;
`;

export const ShareBlock = styled.div`
  display: flex;
  align-items: center;

  & > div {
    flex-grow: 1;
  }

  input {
    margin: 0;
    color: var(--blue_100);
    height: 40px;
    flex-grow: 1;
    display: block;
    min-width: 1px;
    padding: 0 12px;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.01em;
    box-sizing: border-box;
    border: 1px solid #ccdde6;
    background-color: #f5f7fa;
    border-radius: 5px;
  }

  button {
    margin: 0 0 0 10px;
    height: 40px;
    font-size: 16px;
    padding: 0 17px;
    min-width: 110px;
    line-height: 21px;
    font-weight: bold;
    border-radius: 5px;
    border: 1px solid var(--blue_100);
    color: var(--blue_100);
  }
`;

export const ShareBlockDescription = styled.p`
  font-size: 14px;
  line-height: 22px;
  color: #919eaa;
  min-height: 44px;
  margin: 10px 0 0 0;
`;

const formWrapperMobile = media.phone`
  margin-bottom: 20px;
`;

export const FormWrapper = styled.div`
  margin-bottom: 24px;
  ${formWrapperMobile};
`;

export const CallToActionWrapper = styled(FormWrapper)`
  margin-bottom: 8px;
`;

export const TrackingWrapper = styled.div``;

export const LoaderWrapper = styled(Loader)`
  margin-top: 100px;
`;

export const SectionWithSubtitle = styled.div`
  margin-bottom: 15px;
  span {
    margin-bottom: 5px;
  }

  ${ColorField} {
    max-width: 150px;
  }
`;

export const ChatWrapper = styled.div`
  margin-bottom: 15px;
`;
